import { IEntity, SafeAny, TableAction, TableRow } from '@pf/shared-common';

import { ChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { EntityHistoryService } from '../entity-history/entity-history.service';
import { TableActionsBuilder } from '@pf/shared-ui';

export class PlatformCommonTableActions {
    static withEntityHistoryAction<TEntity extends IEntity>(
        builder: TableActionsBuilder<TEntity>,
        entityHistoryService: EntityHistoryService,
        changeTrackingFacadeFactory: ChangeTrackingFacadeFactory<SafeAny>,
        onRowChange?: (
            row: TableRow<TEntity>,
            action: TableAction<TEntity>
        ) => void
    ) {
        return builder.withAction({
            name: 'View History',
            icon: 'view',
            iconColor: 'var(--ant-info-color)',
            onClick: row => {
                const entityId = row.id;
                const facade = changeTrackingFacadeFactory(entityId);
                const entityName = (row.data as SafeAny)[
                    facade.nameField
                ] as string;
                entityHistoryService.create(entityName, facade).open();
            },
            onRowChange: (row, action) => {
                onRowChange?.(row, action);
            },
            textType: 'primary',
        });
    }
}
